/**
 * PDP gallery fix (Sway and similar multi-image products).
 *
 * Problems addressed:
 * - custom.js filterImages calls Slick while desktop uses unslick (≥750px)
 * - #swatch_valor_* inputs were missing on B2C PDP, so filtering never ran
 * - option labels like "Maple - Black" must normalize to maple_black / chêne_blanc_noir
 *
 * Overrides window.filterImages after custom.js. Safe to load on all product pages.
 */
(function () {
  if (typeof window === "undefined") return;

  var MQ_MOBILE = "(max-width: 749px)";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isMobileGallery() {
    return window.matchMedia(MQ_MOBILE).matches;
  }

  function getSlider() {
    if (window.$sliderPdp && window.$sliderPdp.length) return window.$sliderPdp;
    if (typeof jQuery !== "undefined") {
      var $el = jQuery(".pdp-slider").first();
      if ($el.length) {
        window.$sliderPdp = $el;
        return $el;
      }
    }
    return null;
  }

  function getThumbs() {
    if (window.$sliderPdpThumbs && window.$sliderPdpThumbs.length) {
      return window.$sliderPdpThumbs;
    }
    if (typeof jQuery !== "undefined") {
      var $el = jQuery(".pdp-slider-thumbs").first();
      if ($el.length) {
        window.$sliderPdpThumbs = $el;
        return $el;
      }
    }
    return null;
  }

  function slickReady($el) {
    return !!(
      $el &&
      $el.length &&
      typeof $el.hasClass === "function" &&
      $el.hasClass("slick-initialized") &&
      typeof $el.slick === "function"
    );
  }

  function slickCall($el, method, arg) {
    if (!slickReady($el)) return;
    try {
      if (typeof arg === "undefined") $el.slick(method);
      else $el.slick(method, arg);
    } catch (e) {
      /* ignore — unslicked / mid-init */
    }
  }

  /**
   * "Maple - Black" → maple_black
   * "Chêne blanc — Noir" → chêne_blanc_noir
   * "White Oak - Black" → white_oak_black
   */
  function normalizeFilterToken(raw) {
    if (!raw) return "";
    return String(raw)
      .replace(/[—–−]/g, " ")
      .replace(/\//g, " ")
      .replace(/[()&]/g, "")
      .replace(/\u3164/g, " ")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "")
      .toLowerCase();
  }

  function ensureSwatchInputs() {
    var form =
      $("[data-product]") ||
      $(".product__page") ||
      document.body;
    for (var i = 1; i <= 3; i++) {
      if (document.getElementById("swatch_valor_" + i)) continue;
      var input = document.createElement("input");
      input.type = "hidden";
      input.id = "swatch_valor_" + i;
      input.value = "";
      form.appendChild(input);
    }
  }

  /**
   * Prefer the wood/color combo option (first option / selected radio legend).
   * Do NOT fold Size / Grommets into the image filter.
   */
  function syncSwatchFromDom() {
    ensureSwatchInputs();
    var v1 = document.getElementById("swatch_valor_1");
    if (!v1) return;

    var checked = $(
      '.radio__fieldset input[type="radio"]:checked, .swatches input[type="radio"]:checked, [data-single-option-selector]:checked',
    );

    // Broadcast often mirrors selection in a legend / popout label
    var legend =
      $(".radio__fieldset--swatches .radio__legend__value") ||
      $(".radio__fieldset .radio__legend__value") ||
      $("[data-option-value].is-selected") ||
      $(".select-popout__toggle [data-popout-toggle-text]");

    var option1 =
      (checked &&
        (checked.getAttribute("value") ||
          checked.getAttribute("data-value") ||
          checked.value)) ||
      (legend && (legend.textContent || "").trim()) ||
      "";

    // Fall back: first option of current variant from URL / id input
    if (!option1) {
      var idInput = $('input[name="id"]');
      if (idInput && idInput.value && window.meta && window.meta.product) {
        var variants = window.meta.product.variants || [];
        for (var v = 0; v < variants.length; v++) {
          if (String(variants[v].id) === String(idInput.value)) {
            option1 = variants[v].option1 || variants[v].public_title || "";
            break;
          }
        }
      }
    }

    if (option1) {
      v1.value = String(option1)
        .replace(/[—–]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }
  }

  function itemMatches(el, token) {
    if (!token) return false;
    var cat = (el.getAttribute("data-category") || "").toLowerCase();
    if (!cat) return false;
    if (cat.indexOf(token) !== -1) return true;
    // tokens in category are space-separated
    var parts = cat.split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === token) return true;
    }
    return false;
  }

  function setFirstVisibleItem() {
    $all(".template-product .pdp-slider .item").forEach(function (el) {
      el.classList.remove("first_image");
    });
    var items = $all(".template-product .pdp-slider .item");
    for (var i = 0; i < items.length; i++) {
      var style = window.getComputedStyle(items[i]);
      if (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        style.opacity !== "0"
      ) {
        items[i].classList.add("first_image");
        break;
      }
    }
  }

  function filterModalImages(token) {
    $all("#modal-media .i_imagenes, #modal-video .i_imagenes").forEach(
      function (el) {
        var cls = (el.className || "").toLowerCase();
        el.style.display = cls.indexOf(token) !== -1 ? "block" : "none";
      },
    );
  }

  /**
   * Cart bar embeds many .i_imagenes (one per media). Only the first match
   * for the active color may stay visible — otherwise we get a tall stack
   * of thumbnails next to the ADD button.
   */
  function filterCartBarImages(token) {
    var items = $all("#cart-bar .images .item, #cart-bar .i_imagenes");
    if (!items.length) return;
    var shown = false;
    items.forEach(function (el) {
      var cls = (el.className || "").toLowerCase();
      var match = token && cls.indexOf(token) !== -1;
      if (match && !shown) {
        el.style.removeProperty("display");
        shown = true;
      } else {
        el.style.display = "none";
      }
    });
    // Fallback: show the first image if nothing matched
    if (!shown && items[0]) {
      items[0].style.removeProperty("display");
    }
  }

  function filterDesktop(token) {
    var slider = $(".pdp-slider");
    if (!slider) return;
    var items = $all(".item", slider);
    var thumbsRoot = $(".product__images .pdp-slider-thumbs");
    var thumbs = thumbsRoot ? $all(".item", thumbsRoot) : [];
    var any = false;

    items.forEach(function (el) {
      var match = itemMatches(el, token);
      if (match) {
        // Let CSS grid control layout — do not force display:block
        el.style.removeProperty("display");
        any = true;
      } else {
        el.style.display = "none";
      }
    });

    thumbs.forEach(function (el) {
      var match = itemMatches(el, token);
      if (match) el.style.removeProperty("display");
      else el.style.display = "none";
    });

    // If nothing matched (bad alt tags), show everything rather than blank gallery
    if (!any) {
      items.forEach(function (el) {
        el.style.removeProperty("display");
      });
      thumbs.forEach(function (el) {
        el.style.removeProperty("display");
      });
    }

    filterModalImages(token);
    filterCartBarImages(token);
  }

  function filterMobile(token) {
    var $slider = getSlider();
    var $thumbs = getThumbs();

    slickCall($slider, "slickUnfilter");
    slickCall($thumbs, "slickUnfilter");

    function slideMatches(index, slide) {
      var cat = (window.jQuery(slide).data("category") || "") + "";
      var parts = cat.toLowerCase().split(/\s+/);
      return (
        parts.indexOf(token) !== -1 ||
        cat.toLowerCase().indexOf(token) !== -1
      );
    }

    if (slickReady($slider)) {
      slickCall($slider, "slickFilter", slideMatches);
      slickCall($slider, "slickGoTo", 0);
    } else {
      filterDesktop(token);
      return;
    }

    if (slickReady($thumbs)) {
      slickCall($thumbs, "slickFilter", slideMatches);
      slickCall($thumbs, "slickGoTo", 0);
    }

    filterModalImages(token);
    filterCartBarImages(token);
  }

  function filterImages() {
    syncSwatchFromDom();
    var v1 = document.getElementById("swatch_valor_1");
    if (!v1 || !v1.value) {
      // No color context — leave gallery alone (avoid blanking)
      return false;
    }

    var token = normalizeFilterToken(v1.value);
    if (!token) return false;

    // Optional 2nd swatch (fabric combo etc.)
    var v2 = document.getElementById("swatch_valor_2");
    if (v2 && v2.value) {
      token = token + "-" + normalizeFilterToken(v2.value);
    }
    var v3 = document.getElementById("swatch_valor_3");
    if (v3 && v3.value) {
      token = token + "-" + normalizeFilterToken(v3.value);
    }

    document.documentElement.classList.add("pdp-gallery-ready");

    if (isMobileGallery()) {
      filterMobile(token);
    } else {
      filterDesktop(token);
    }

    setTimeout(setFirstVisibleItem, 50);
    setTimeout(setFirstVisibleItem, 300);
    return true;
  }

  // Public API — override custom.js
  window.filterImages = filterImages;
  window.setFirstVisibleItem = setFirstVisibleItem;
  window.isMobile = isMobileGallery;

  function boot() {
    ensureSwatchInputs();
    syncSwatchFromDom();
    filterImages();

    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (
        t.matches(
          '[data-single-option-selector], .radio__fieldset input[type="radio"], .swatches input, input[name="id"]',
        )
      ) {
        setTimeout(filterImages, 50);
        setTimeout(filterImages, 250);
      }
    });

    document.addEventListener("click", function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest(
            ".swatches label, .radio__fieldset label, [data-swatch], .select-popout__option",
          )
        : null;
      if (t) {
        setTimeout(filterImages, 80);
        setTimeout(filterImages, 300);
      }
    });

    [
      "theme:variant:change",
      "variant:change",
      "shopify:section:load",
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(filterImages, 100);
      });
    });

    window.addEventListener(
      "resize",
      (function () {
        var t;
        return function () {
          clearTimeout(t);
          t = setTimeout(filterImages, 200);
        };
      })(),
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      // After custom.js inline filterImages() on parse
      setTimeout(boot, 0);
    });
  } else {
    setTimeout(boot, 0);
  }
})();
